define('Components/LandingWidget/js/models/LandingWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app'],function(_,Backbone,WidgetInstanceModel,app, sprintf){

    return WidgetInstanceModel.extend({
        
        name:'LandingWidgetModel'
        
    })
});
